import { render, staticRenderFns } from "./ProviderModule.vue?vue&type=template&id=3b69a331&scoped=true"
import script from "./ProviderModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderModule.vue?vue&type=style&index=0&id=3b69a331&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b69a331",
  null
  
)

export default component.exports